// extracted by mini-css-extract-plugin
export var fadeInOut = "_48-3";
export var icon = "_48-4";
export var savedIndicator = "_48-2";
export var savingIndicator = "_48-0";
export var spin = "_48-1";